import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  notification,
  Select,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeaders from "../../components/pageHeaders";
import { DELETE, POST } from "../../utils/apiRequest";
import { API } from "../../config/Api";
import { CiSearch } from "react-icons/ci";
import { IoReload } from "react-icons/io5";
import HorizontalLineLoader from "../components/loader";
import Loading from "../../components/loading";
import DiscountDataTable from "./dataTable";
import DiscountFormModal from "./form";

function DiscountScreen() {
  const navigate = useNavigate();
  const [form] = useForm();
  const [Notifications, contextHolder] = notification.useNotification();

  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);

  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});

  const [page, setPage] = useState(1);
  const [take, setTake] = useState(30);
  const [meta, setMeta] = useState<any>({});

  useEffect(() => {
    getDiscount();
  }, [page, take]);

  const getDiscount = async () => {
    try {
      setIsLoading2(true);
      let obj = {
        status: form.getFieldValue("status"),
        startDate: form.getFieldValue("date"),
        query: form.getFieldValue("query"),
        page: page,
        take: take,
      };
      let api = API.DISCOUNT_LIST;
      const response: any = await POST(api, obj);
      if (response?.status) {
        setData(response?.data);
        setIsLoading(false);
        setMeta(response?.meta);
      } else {
        setData([]);
        setIsLoading(false);
      }
      setIsLoading2(false);
    } catch (err) {
      setIsLoading(false);
      setIsLoading2(false);
    }
  };
  const editUser = (user: any) => {
    try {
      setSelectedItem(user);
      setModalVisible(!modalVisible);
    } catch (err) {
      console.log(err);
    }
  };

  const onView = (val: any) => {
    navigate(`/Auth/discountDetails/${val}`, { state: { val } });
  };
  const deleteDiscount = async (id: any) => {
    try {
      setIsLoading2(true);
      let api = API.DISCOUNT_DELETE + id;
      let Delete: any = await DELETE(api);
      if (Delete?.status) {
        setIsLoading2(false);
        Notifications["success"]({
          message: "Discount Deleted",
        });
        getDiscount();
      } else {
        setIsLoading2(false);
        Notifications["error"]({
          message: "Discount not deleted",
        });
      }
    } catch (err) {
      setIsLoading2(false);
      Notifications["error"]({
        message: "Network error. Discount not deleted",
      });
    }
  };
  return (
    <div>
      {contextHolder}
      <PageHeaders title={"Discount"} backButton={true} loading={isLoading2}>
        <Form form={form} onValuesChange={getDiscount}>
          <div className="jobScreen-PageHeaderBox">
            <Form.Item name={"query"} noStyle>
              <Input
                style={{ width: 200 }}
                placeholder="Search"
                allowClear
                suffix={<CiSearch size={16} color="#000" />}
              />
            </Form.Item>
            <Form.Item name={"status"} noStyle>
              <Select allowClear style={{ minWidth: 100 }} placeholder="Status">
                <Select.Option value={null}>All</Select.Option>
                <Select.Option value={true}>Active</Select.Option>
                <Select.Option value={false}>Inactive</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name={"date"} noStyle>
              <DatePicker placeholder="Create Date" style={{ minWidth: 100 }} />
            </Form.Item>
            <Form.Item noStyle>
              <Button onClick={() => editUser({})} type="primary">
                Create +
              </Button>
            </Form.Item>

            <Button className="refreshBtn" onClick={() => getDiscount()}>
              <IoReload color="#000" size={15} />
            </Button>
          </div>
        </Form>
      </PageHeaders>
      {isLoading2 ? <HorizontalLineLoader /> : null}
      <div className="screenBox">
        <Card>
          {isLoading ? (
            <Loading />
          ) : (
            <DiscountDataTable
              data={data}
              onEdit={(item: any) => editUser(item)}
              onView={(item: any) => onView(item)}
              delete={(id: any) => deleteDiscount(id)}
              meta={meta}
              onPageChange={(page: number, pageSize: number) => {
                setIsLoading2(true);
                setPage(page);
                setTake(pageSize);
              }}
            />
          )}
        </Card>
      </div>
      {modalVisible ? (
        <DiscountFormModal
          data={selectedItem}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
          onSuccess={() => {
            setIsLoading2(true);
            editUser({});
            getDiscount();
          }}
        />
      ) : null}
    </div>
  );
}

export default DiscountScreen;
